import debug from './diagnostics';

const log = debug('json');

/**
 * Safely run JSON method.
 *
 * @param {String} name Function name.
 * @param {...[Mixed]} args Valid arguments
 * @returns {Mixed|undefined} Parsed or stringified object.
 * @api private
 */
function run(name, ...args) {
  try {
    return JSON[name](...args);
  } catch (error) {
    log(error.message);
  }
}

/**
 * Proxy to JSON.stringify.
 *
 * @returns {String|undefined} stringified representation of the provided arguments.
 * @api public
 */
function stringify() {
  return run('stringify', ...arguments);
}

/**
 * Proxy to JSON.parse.
 *
 * @returns {Object|undefined} parsed object or undefined.
 * @api public
 */
function parse() {
  return run('parse', ...arguments);
}

//
// Export both functions.
//
export {
  stringify,
  parse
};
